var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.307,
    height: 90,
    viewBox: "0 0 75.307 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.636,0,48.416,44.575,93.191,90Z",
    transform: "translate(-18.329)",
    fill: "#76777a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,47.077,41.828,88.905l.876-.876-.006-.007L57.32,73.171l.006-.006L57,72.841l-.559-.547L41.821,87.141,1.746,47.071,43.592,4.386,56.816,19.2l.889-.871L43.636,2.565Z",
    transform: "translate(0 -0.971)",
    fill: "#e5e6ea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconBullet);
export default __webpack_public_path__ + "static/media/logo-icon-bullet.324efcaac828e095322c4f08c61e19ad.svg";
export { ForwardRef as ReactComponent };